import { validator } from "@/utils/validator";

export const companyBranchExportCsvSchema = validator.object().shape({
  dataFormat: validator.string().isSelection().trim().emptyToNull().label("データ様式").required(),
  firstRowSpecification: validator.string().isSelection().trim().emptyToNull().label("先頭行の仕様").required(),
  characterCode: validator.string().isSelection().trim().emptyToNull().label("文字コード").required(),
  delimiter: validator.string().isSelection().trim().emptyToNull().label("区切り文字").required(),
});
